import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import Button from 'components/Button'
import Layout from 'components/Layout/Layout'
import { style } from 'theme'

export const Container = styled.div<{ isLoading?: boolean }>`
  margin: 0 auto;
  max-width: 800px;
  background-color: ${theme.colors.white};
  border-radius: 10px;
  height: 520px;

  ${props =>
    props.isLoading &&
    `
    height: 680px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 64px;
  `}

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    height: inherit;
    box-shadow: none;
    border-radius: 0;

  ${props =>
    props.isLoading &&
    `
    display: flex;
    margin-top: -70px;
  `}
`

export const StyledLayout = styled(Layout)`
  padding-top: 10px;
  
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    max-height 80vh;
  }
`

export const LineContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;

  &:not(:last-child) {
    margin: 0 auto 30px;

    @media screen and (max-width: ${theme.breakpoints.sm}px) {
      margin: 0 auto 15px;
    }
  }
`

export const LineText = styled.p`
  margin: 0 0 0 10px;
  font-size: 14px;
  line-height: 22px;
  height: 60px;
  color: ${theme.colors.slate};
  width: 360px;
  z-index: 1;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    height: 88px;
    width: 275px;
  }
`

export const Logo = styled.img`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  text-align: center;
  vertical-align: top;

  @media screen and (max-width: ${props => props.theme.breakpoints.md}px) {
    width: 28px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: 24px;
  }

  &:focus {
    outline: none;
  }
`

export const StyledButtonImage = styled.img`
  width: 16px;
  height: 12px;
  margin-left: 10px;
  margin-top: 3px;
  display: flex;
  align-items: center;
  text-align: center;
  vertical-align: center;

  @media screen and (max-width: ${props => props.theme.breakpoints.md}px) {
    width: 28px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: 16px;
  }

  &:focus {
    outline: none;
  }
`

export const Content = styled.div`
  width: 415px;
  margin: 0 auto;
  padding: 10px 30px 0 30px;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    width: 350px;
    padding: 0 30px 0 0;
    height: inherit;
  }
`

export const ItemContainer = styled.div`
  margin: 10px auto 0;
  padding-bottom: 25px;
`

export const Title = styled.p`
  color: ${theme.colors.slate};
  font-size: 40px;
  margin: 30px 0 20px;
  text-align: left;
  font-weight: 600;
  line-height: 55px;
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin: 0;
  }
`

export const Text = styled.p`
  color: ${theme.colors.slate};
  margin-bottom: 30px;
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  width: 400px;
  height: 66px;
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    width: 315px;
  }
`

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  z-index: 1;
  padding: 14px 21px 10px 24px;
  width: 206px;
  height: 44px;
  margin-bottom: 40px;
  margin-left: 0px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 14px 24px 10px;
    bottom: 15px;
    width: 127px;
    position: relative;
  }
`

export const StyledImage = styled.img`
  position: relative;
  left: 375px;
  bottom: 152px;
  width: auto;
  height: auto;
  z-index: 0;
  border-radius: 10px;
`

export const StyledMobileImage = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: auto;
  height: auto;
  z-index: 0;
`

export const StepNumber = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: ${theme.colors.purple};
  flex: 0 0 30px;
`
export const StepText = styled.div`
  color: ${theme.colors.white};
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
`
